/**
 * Purpose: Consistent <select> filter control used by SocietySectionToolbar children.
 *
 * Inputs:
 *   - label (string): Label rendered above the control.
 *   - value (string), onChange (fn<event>): controlled select state.
 *   - children (ReactNode): <option> elements to render.
 *
 * Outputs: Rendered labelled select JSX.
 */
import React from 'react';

const SectionFilterSelect = ({ label, value, onChange, children, id }) => {
  const selectId = id || `filter-${(label || '').toLowerCase().replace(/\s+/g, '-')}`;
  return (
    <div>
      <label htmlFor={selectId} className="block text-sm font-medium text-gray-700 mb-1 sm:mb-2">
        {label}
      </label>
      <select
        id={selectId}
        value={value}
        onChange={onChange}
        className="w-full px-3 py-2 border border-gray-300 rounded-lg sm:rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm bg-white"
      >
        {children}
      </select>
    </div>
  );
};

export default SectionFilterSelect;
